import { useTypedParams } from '@sorare/routing';

import { RewardsEssenceLayout } from '#src/layouts/rewards/RewardsEssenceLayout/index.tsx';

import type { LayoutParams } from './__generated__/routeParams.ts';

const RewardsEssenceLayoutComponent = () => {
  const { quality, rarity } = useTypedParams<LayoutParams>();
  return <RewardsEssenceLayout quality={quality} rarity={rarity} />;
};
export default RewardsEssenceLayoutComponent;
